import { useTheme } from '@mui/material'
import { TextFieldWithDarkMode } from 'dark-mode-components'

const DistanceInputField = ({
  distance,
  setDistance,
  isDarkBackdrop,
}: {
  distance: number
  setDistance: (distance: number) => void
  isDarkBackdrop: boolean
}) => {
  const theme = useTheme()

  const onDistanceChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDistance(Number(event.target.value))
  }

  return (
    <TextFieldWithDarkMode
      className="has-label"
      theme={theme}
      isDarkBackdrop={isDarkBackdrop}
      inputProps={{
        min: 0.2,
        step: 0.1,
        max: 1,
      }}
      type="number"
      label="Distance"
      value={distance || ''}
      onChange={onDistanceChange}
      error={distance > 1}
      helperText={distance > 1 ? 'Please use a value between 0 and 1' : null}
      sx={{
        width: '240px',
      }}
    />
  )
}

export default DistanceInputField
